import { TCollector } from './Collect';
import { CollectorUtil } from './CollectorUtil';

/**
 * 模块加载时间数据收集指令
 * 指令绑定参数说明：
 * @params {String} moduleName, 模块名称，必传
 * @params {Boolean} clickLeave, 是否在元素发生点击后停止收集，可选
 */
const initCollect = ({ obseverHandler, stopCollectHandler }) => {
  return {
    bind (el, binding) {
      obseverHandler(el, binding);
      if (binding && binding.value && binding.value.clickLeave) {
        stopCollectHandler(el)
      }
    }
  }
}

/**
 * 功能：模块加载时间数据收集初始化函数
 * 使用示例：
 *  import { initCollector } from '@mtfe/metric';
 *  const { collect } = initCollector({ abType: 'xxx' })
 *  Vue.directive('metric-collect', collect);
 *  <div v-metric-collect="{moduleName: xxx, clickLeave: [true|false]}"></div>
 * @param  {Object} options 可选项
 * @param  {Object} options[abType] 项目名称，作为获取AB数据配置的key，比如'`_pgy_wink_${options[abType]}`'
 * @return Object         collect - 数据收集指令；collector数据收集实例
 */
const initCollector = options => {
  // 兼容SSR场景
  if (typeof window === 'undefined') {
    return {
      collect: {},
      collector: {
        getAbResult: function() {}
      }
    }
  }
  // 实例化数据收集器
  const collector = new TCollector(options);

  // 导出收集器实例的方法，以便在其他地方使用
  const obseverHandler = collector.obseverHandler.bind(collector);
  const stopCollectHandler = collector.stopCollect.bind(collector);

  // 导出数据采集指令
  const collect = initCollect({ obseverHandler, stopCollectHandler });

  return {
    collect,
    collector
  }
}

export { initCollector, CollectorUtil };
